<template>
  <el-menu v-bind:default-active="defaultActive" class="sidebar-menu" text-color="#FFFFFF" active-text-color="#000000"
    @open="handleOpen" @close="handleClose">
    <!-- 个人账户 -->
    <el-submenu index="1" v-if="permissionList && permissionList.indexOf('user:person:account') != -1">
      <template slot="title">
        <img class="cl-header" src="../../assets/images/headericon.png" />
        <span>&nbsp;{{$t('self.sidebarClass.individualAccount')}}</span>
      </template>
      <el-menu-item-group>
        <!-- 个人账户总览 -->
        <router-link to="/account/personaloverview">
          <el-menu-item index="1-1">•&nbsp;&nbsp;{{$t('self.sidebarClass.personalOverview')}}</el-menu-item>
        </router-link>

        <!-- 个人充值 -->
        <router-link to="/account/recharge">
          <el-menu-item index="1-2">•&nbsp;&nbsp;{{$t('self.sidebarClass.personalCredit')}}</el-menu-item>
        </router-link>

        <!--个人转账-->
        <router-link to="/account/personalTransfer">
          <el-menu-item index="1-3">•&nbsp;&nbsp;{{$t('self.sidebarClass.personalAccountTransfer')}}</el-menu-item>
        </router-link>

        <!-- 个人交易明细 -->
        <router-link to="/account/personalDetailed">
          <el-menu-item index="1-4">•&nbsp;&nbsp;{{$t('self.sidebarClass.personalDetails')}}</el-menu-item>
        </router-link>
      </el-menu-item-group>
    </el-submenu>
    <!-- 公司账户 -->
    <el-submenu index="2" v-if="permissionList && permissionList.indexOf('user:company:account') != -1">
      <template slot="title">
        <img class="cl-header" src="../../assets/images/corporicon.png" />
        <span>&nbsp;{{$t('self.sidebarClass.companyAccount')}}</span>
      </template>
      <el-menu-item-group>
        <!-- 公司账户总览 -->
        <router-link to="/account/corporateaccount">
          <el-menu-item index="2-1">•&nbsp;&nbsp;{{$t('self.sidebarClass.companyOverview')}}</el-menu-item>
        </router-link>

        <!-- 公司充值 -->
        <router-link to="/account/enterpriserecharge">
          <el-menu-item index="2-2">•&nbsp;&nbsp;{{$t('self.sidebarClass.companyRecharge')}}</el-menu-item>
        </router-link>

        <!-- 公司转账 -->
        <router-link to="/account/companyTransfer">
          <el-menu-item index="2-3">•&nbsp;&nbsp;{{$t('self.sidebarClass.companyTransfer')}}</el-menu-item>
        </router-link>

        <!-- 购买会员 -->
        <!-- <router-link to="/account/purchasemember">
          <el-menu-item index="2-4">•&nbsp;&nbsp;{{$t('self.sidebarClass.purchaseMember')}}</el-menu-item>
        </router-link> -->

        <!-- 公司交易明细 -->
        <router-link to="/account/enterpriselDetailed">
          <el-menu-item index="2-5">•&nbsp;&nbsp;{{$t('self.sidebarClass.companyDetails')}}</el-menu-item>
        </router-link>
      </el-menu-item-group>
    </el-submenu>
    <!-- 账号管理 -->
    <el-submenu index="3" v-if="permissionList && permissionList.indexOf('user:company:accountmanage') != -1">
      <template slot="title">
        <img class="cl-header" src="../../assets/images/manageicon.png" />
        <span>&nbsp;{{$t('self.sidebarClass.accountManagement')}}</span>
      </template>
      <el-menu-item-group>
        <!-- 公司关联账号管理 -->
        <router-link to="/account/accountmanagement">
          <el-menu-item index="3-1">•&nbsp;&nbsp;{{$t('self.sidebarClass.companyManagement')}}</el-menu-item>
        </router-link>
      </el-menu-item-group>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        permissionList: [],
        listData: [],
        defaultActive: "1",
        navConfig: {
          //个人账户总览
          "/account/personaloverview": "1-1",
          //个人账户充值 ==>充值
          "/account/recharge": "1-2",
          //个人账户转账 ==>转账
          "/account/personalTransfer": "1-3",
          //个人账户充值 ==>交易明细
          "/account/personalDetailed": "1-4",
          //公司账户总览
          "/account/corporateaccount": "2-1",
          //公司账户充值 ==>充值
          "/account/enterpriserecharge": "2-2",
          //公司账户充值 ==>充值转账
          "/account/companyTransfer": "2-3",
          //公司账户充值 ==>购买会员
          "/account/purchasemember": "2-4",
          //公司账户充值 ==>交易明细
          "/account/enterpriselDetailed": "2-5",
          //企业关联账户管理
          "/account/accountmanagement": "3-1"
        }
      };
    },
    mounted() {
      this.userPermission()
      var _this = this;
      _this.defaultActive = _this.navConfig[_this.$route.path];
    },
    methods: {
      userPermission() {

        let _this = this
        this.$axios.get('/menu/userPermission', {
            params: {

            }
          })
          .then(res => {
            console.log("给手机发送验证码============", res);
            if (res.code == 0) {

              _this.permissionList = res.data
              _this.listData = res.data[0]
              _this.listData2 = res.data[1]
              _this.listData3 = res.data[2]
              _this.listData4 = res.data[3]
            }
            if (res.code == -1) {
              _this.msg = res.data.msg
            }
          })
          .catch(error => {
            console.log(error);
            this.abnormalSituation()
          });
      },
    },

    computed: {
      activeMenu() {
        const route = this.$route
        const {
          path
        } = route
        return path
      }
    }
  }

</script>

<style lang="scss" scoped>
  .sidebar-menu {
    min-width: 220px;
    height: 100%;
  }

  .cl-header {
    width: 18px;
    height: 18px;
  }

  .el-menu-item.is-active {
    background-image: linear-gradient(#F8EBA3, #EFD16A);
    font-weight: bold;
  }

</style>
